/* ==========================================================================
   Hero slider (sections/section-hero-slider.liquid)
   - Autoplay con progreso en el punto activo; pausa al pasar el ratón,
     al enfocar, al salir de pantalla o con el botón de pausa.
   - Flechas, puntos, swipe y teclado (← →).
   - Editor de Shopify: al seleccionar un slide se muestra y se pausa.
   - Botones "#id-de-sección": scroll suave (acepta el id corto de la sección
     de la plantilla, p. ej. #landing-decaf).
   ========================================================================== */
(function () {
  'use strict';

  var LEAVE_MS = 550;

  function HeroSlider(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hs-dot]'));
    this.index = 0;
    this.speed = (parseInt(root.getAttribute('data-speed'), 10) || 7) * 1000;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && this.slides.length > 1;
    this.hover = false;
    this.focus = false;
    this.visible = true;
    this.userPaused = false;
    this.editorPaused = false;

    this.bind();
    this.observe();
    this.schedule();
  }

  HeroSlider.prototype.bind = function () {
    var self = this;
    var root = this.root;

    var prev = root.querySelector('[data-hs-prev]');
    var next = root.querySelector('[data-hs-next]');
    var pause = root.querySelector('[data-hs-pause]');
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () { self.go(parseInt(dot.getAttribute('data-hs-dot'), 10)); });
    });

    if (pause) {
      pause.addEventListener('click', function () {
        self.userPaused = !self.userPaused;
        pause.setAttribute('aria-pressed', String(self.userPaused));
        pause.setAttribute('aria-label', self.userPaused ? 'Reanudar el carrusel' : 'Pausar el carrusel');
        root.classList.toggle('is-user-paused', self.userPaused);
        self.schedule();
      });
    }

    root.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') { self.hover = true; self.schedule(); }
    });
    root.addEventListener('pointerleave', function () { self.hover = false; self.schedule(); });
    // Pausa solo con foco de teclado (un clic en un punto no debe parar el autoplay)
    root.addEventListener('focusin', function (e) {
      var keyboard = true;
      try { keyboard = e.target.matches(':focus-visible'); } catch (err) { /* navegador antiguo */ }
      if (keyboard) { self.focus = true; self.schedule(); }
    });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { self.focus = false; self.schedule(); }
    });

    root.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea')) return;
      if (e.key === 'ArrowLeft') { self.go(self.index - 1); }
      if (e.key === 'ArrowRight') { self.go(self.index + 1); }
    });

    // Swipe horizontal
    var startX = null;
    var startY = null;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      startX = e.clientX;
      startY = e.clientY;
    }, { passive: true });
    root.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      startX = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        self.go(self.index + (dx < 0 ? 1 : -1));
      }
    });
    root.addEventListener('pointercancel', function () { startX = null; });

    document.addEventListener('visibilitychange', function () { self.schedule(); });

    // Botones con ancla → scroll suave a la sección
    root.addEventListener('click', function (e) {
      var link = e.target.closest('a[data-hs-anchor]');
      if (!link) return;
      var hash = link.getAttribute('href') || '';
      var id = hash.slice(hash.indexOf('#') + 1);
      if (!id) return;
      var target = findSection(id);
      if (!target) return;
      e.preventDefault();
      scrollToTarget(target);
    });
  };

  HeroSlider.prototype.observe = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      self.visible = entries[0].isIntersecting;
      self.schedule();
    }, { threshold: 0.25 }).observe(this.root);
  };

  HeroSlider.prototype.isPlaying = function () {
    return this.autoplay && !this.hover && !this.focus && this.visible && !this.userPaused &&
      !this.editorPaused && document.visibilityState !== 'hidden';
  };

  // Arranca/para el temporizador y sincroniza la barra de progreso del punto
  HeroSlider.prototype.schedule = function (restart) {
    var self = this;
    var playing = this.isPlaying();
    this.root.classList.toggle('is-playing', this.autoplay);
    this.root.classList.toggle('is-paused', this.autoplay && !playing);

    if (restart) {
      clearTimeout(this.timer);
      this.remaining = this.speed;
      this.startedAt = null;
    }
    if (this.remaining == null) this.remaining = this.speed;

    if (playing) {
      if (this.startedAt) return; // ya está en marcha
      this.startedAt = Date.now();
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        self.startedAt = null;
        self.go(self.index + 1);
      }, this.remaining);
    } else if (this.startedAt) {
      this.remaining = Math.max(400, this.remaining - (Date.now() - this.startedAt));
      this.startedAt = null;
      clearTimeout(this.timer);
    }
  };

  HeroSlider.prototype.go = function (to) {
    var n = this.slides.length;
    if (n < 2) return;
    to = ((to % n) + n) % n;
    if (to === this.index) return;

    var current = this.slides[this.index];
    var next = this.slides[to];

    current.classList.remove('is-active');
    current.classList.add('is-leaving');
    current.setAttribute('aria-hidden', 'true');
    current.setAttribute('inert', '');
    clearTimeout(current.__leaveTimer);
    current.__leaveTimer = setTimeout(function () { current.classList.remove('is-leaving'); }, LEAVE_MS);

    next.classList.remove('is-leaving');
    next.removeAttribute('aria-hidden');
    next.removeAttribute('inert');
    next.classList.add('is-active');

    this.dots.forEach(function (dot, i) {
      var active = i === to;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
      // Reinicia la animación de progreso
      var fill = dot.querySelector('.hs__dot-fill');
      if (active && fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
    });

    this.index = to;
    this.schedule(true);
  };

  /* ---------- Anclas ---------- */
  function findSection(id) {
    var el = document.getElementById(id);
    if (el) return el;
    // Id corto de la plantilla: "landing-decaf" → "shopify-section-template--123__landing-decaf"
    try {
      return document.querySelector('[id$="__' + CSS.escape(id) + '"]');
    } catch (err) {
      return null;
    }
  }

  function headerOffset() {
    var header = document.querySelector('.js-header-sticky, .header--sticky');
    if (!header) return 0;
    // Modo "scroll up": al bajar hasta la sección el header se oculta, no hay que compensarlo
    if (header.classList.contains('js-header-scroll')) return 0;
    var pos = getComputedStyle(header).position;
    return pos === 'sticky' || pos === 'fixed' ? header.getBoundingClientRect().height : 0;
  }

  function scrollToTarget(target) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------- Init + editor de temas ---------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-hero-slider]').forEach(function (root) {
      if (!root.__hs) root.__hs = new HeroSlider(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-hs-slide]') || e.target;
    var root = slide.closest && slide.closest('[data-hero-slider]');
    if (!root || !root.__hs) return;
    var hs = root.__hs;
    var i = hs.slides.indexOf(slide);
    hs.editorPaused = true;
    if (i > -1) hs.go(i);
    hs.schedule();
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-hero-slider]');
    if (!root || !root.__hs) return;
    root.__hs.editorPaused = false;
    root.__hs.schedule();
  });
})();
